/* eslint-disable no-redeclare */
import { AtsHttpClient } from '../ats-http-client';
import { settings } from '../settings';
import { Layout } from './types';

const atsHttpClient = new AtsHttpClient();

export async function getRootMenu(): Promise<Layout.SectionItem[]> {
  const data = await atsHttpClient.get<Layout.RootMenu>('/layout/root/menu', settings.layout('GET'));
  return data.items;
}

export async function getAllAvailablePages(): Promise<Layout.PageViewModelBase[]> {
  return atsHttpClient.get<Layout.PageViewModelBase[]>('/layout/pages', settings.layout('GET'));
}

export async function getAllCollections(): Promise<Layout.CollectionViewModel[]> {
  return atsHttpClient.get<Layout.CollectionViewModel[]>('/layout/collections', settings.layout('GET'));
}

export async function getPageByIdOrSlug(idOrSlug: string): Promise<Layout.PageView> {
  if (!idOrSlug) {
    return {} as Layout.PageView;
  }
  return atsHttpClient.get(`/layout/pages/${idOrSlug}`, settings.layout('GET'));
}

export async function getRootMenuItemsBySlug(
  type: Layout.SectionItemType,
  slug: string,
): Promise<Layout.PageView | Layout.SectionItem[]> {
  let menuItemsQuery = type === Layout.MenuLinkType.MENU ? '/items' : '';
  return atsHttpClient.get(`layout/${type}s/${slug}${menuItemsQuery}`, settings.layout('GET'));
}

interface BaseSectionItemsOptions {
  skip?: number;
  take?: number;
}

export interface SectionItemsLinkOptions extends BaseSectionItemsOptions {
  link: string;
}

export interface SectionItemsSlugOptions extends BaseSectionItemsOptions {
  pageSlug: string;
  sectionSlug: string;
}

export type SectionItemsOptions = SectionItemsLinkOptions | SectionItemsSlugOptions;

export async function getSectionItems(options: SectionItemsOptions): Promise<Layout.SectionItem[]> {
  const { skip, take } = options;
  const paginationParams = skip ? `?skip=${skip}&take=${take}` : '';
  const path =
    'pageSlug' in options ? `/layout/pages/${options.pageSlug}/sections/${options.sectionSlug}/items` : options.link;

  const response = await atsHttpClient.get<Layout.SectionItems>(path + paginationParams, settings.layout('GET'));
  return response.data;
}

export async function getSingleMenuBySlug(slug: string): Promise<unknown> {
  return atsHttpClient.get(`/layout/menus/${slug}`, settings.layout('GET'));
}

export async function getSingleCollectionBySlug(slug: string): Promise<Layout.CollectionDetailsViewModel> {
  if (!slug) {
    return {} as Layout.CollectionDetailsViewModel;
  }

  return atsHttpClient.get<Layout.CollectionDetailsViewModel>(`/layout/collections/${slug}`, settings.layout('GET'));
}
